<div class="col-xl payroll-detail-wrap" *ngIf="payroll">
    <div class="employee-breadcrumb mb-3">
        <a [routerLink]="['/employee/list']">Listado de colaboradores</a> /
        <a [routerLink]="['/employee', employeeId]">Detalles del colaborador</a> /
        <a [routerLink]="['/employee', employeeId, 'payroll']">Nómina del colaborador</a> /
        <span class="current">Recibo {{payroll.payroll_number}}</span>
    </div>

    <div class="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3">
        <div class="d-flex align-items-center gap-3">
            <button type="button" class="employee-back-btn" (click)="goBackToList()" title="Regresar al listado">
                <i class="ti ti-arrow-left"></i>
            </button>
            <h4 class="mb-0 employee-name">Recibo de nómina</h4>
        </div>
        <button type="button" class="payroll-download-btn" (click)="downloadPdf()" [disabled]="downloadingPdf">
            <i class="ti" [class.ti-download]="!downloadingPdf" [class.ti-loader-2]="downloadingPdf"></i>
            Descargar PDF
        </button>
    </div>

    <div class="payroll-detail-panel">
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
            <div class="d-flex align-items-center gap-3">
                <div class="payroll-avatar">
                    <img *ngIf="employee?.photo" [src]="employee.photo" alt="Foto del colaborador">
                    <span *ngIf="!employee?.photo">{{initials}}</span>
                </div>
                <div>
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                        <h5 class="mb-0 employee-name">{{fullName}}</h5>
                        <span class="employee-status-badge" [class.is-active]="statusIsActive" [class.is-inactive]="!statusIsActive">
                            <span class="dot"></span>{{statusLabel}}
                        </span>
                    </div>
                    <p class="employee-subtitle mb-0">{{employee?.position?.name || 'Sin puesto'}} &nbsp;|&nbsp; {{employee?.department?.name || 'Sin departamento'}}</p>
                </div>
            </div>
            <div class="d-flex align-items-center gap-2">
                <span class="text-muted">Neto a pagar en efectivo</span>
                <div class="payroll-net-badge">{{formatCurrency(payroll.net_cash_total)}}</div>
            </div>
        </div>

        <div class="payroll-data-card mb-4">
            <p class="payroll-data-title">Datos del colaborador</p>
            <div class="row g-3">
                <div class="col-12 col-md-4">
                    <div class="payroll-data-field"><span class="label">CURP:</span><span class="value">{{employee?.curp || '--'}}</span></div>
                    <div class="payroll-data-field"><span class="label">RFC:</span><span class="value">{{employee?.rfc || '--'}}</span></div>
                    <div class="payroll-data-field"><span class="label">R. IMSS:</span><span class="value">{{employee?.nss || '--'}}</span></div>
                    <div class="payroll-data-field"><span class="label">Régimen:</span><span class="value">{{employee?.tax_regime || '--'}}</span></div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="payroll-data-field"><span class="label">Registro patronal:</span><span class="value">{{employee?.employer_registration || '--'}}</span></div>
                    <div class="payroll-data-field"><span class="label">Puesto:</span><span class="value">{{employee?.position?.name || '--'}}</span></div>
                    <div class="payroll-data-field"><span class="label">Fecha de alta:</span><span class="value">{{formatDate(employee?.hire_date)}}</span></div>
                    <div class="payroll-data-field"><span class="label">Salario diario:</span><span class="value">{{formatCurrency(employee?.daily_salary)}}</span></div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="payroll-data-field"><span class="label">No. Nómina:</span><span class="value strong">{{payroll.payroll_number}}</span></div>
                    <div class="payroll-data-field"><span class="label">Periodo desde:</span><span class="value">{{formatDate(payroll.period_start)}}</span></div>
                    <div class="payroll-data-field"><span class="label">Hasta:</span><span class="value">{{formatDate(payroll.period_end)}}</span></div>
                    <div class="payroll-data-field"><span class="label">Estatus del trabajador:</span><span class="value strong text-success">{{statusLabel}}</span></div>
                    <div class="payroll-data-field"><span class="label">Días trabajados:</span><span class="value">{{formatNumber(payroll.worked_days)}}</span></div>
                    <div class="payroll-data-field"><span class="label">Faltas:</span><span class="value">{{formatNumber(payroll.absences)}}</span></div>
                    <div class="payroll-data-field"><span class="label">Recibo electrónico:</span>
                        <span class="value strong" [class.text-success]="isStamped" [class.text-warning]="payroll.cfdi_status === 'pending'" [class.text-danger]="payroll.cfdi_status === 'error'">{{cfdiStatusLabel}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row g-4 mb-4">
            <div class="col-12 col-lg-6">
                <div class="payroll-table-card">
                    <div class="payroll-table-header">
                        <i class="ti ti-trending-up text-success"></i>
                        <span class="text-success">Percepciones</span>
                    </div>
                    <table class="payroll-table">
                        <thead>
                            <tr><th class="w-clave">Clave</th><th>Concepto</th><th class="text-end w-qty">Cantidad</th><th class="text-end w-amt">Importe</th></tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of earnings">
                                <td class="w-clave">{{item.code}}</td>
                                <td>{{item.concept}}</td>
                                <td class="text-end w-qty">{{formatNumber(item.quantity)}}</td>
                                <td class="text-end w-amt">{{formatCurrency(item.amount)}}</td>
                            </tr>
                            <tr *ngIf="!earnings.length"><td colspan="4" class="text-center text-muted py-3">Sin percepciones registradas</td></tr>
                        </tbody>
                    </table>
                    <div class="payroll-table-total total-success">
                        <span>Total de percepciones</span>
                        <span>{{formatCurrency(payroll.total_earnings)}}</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="payroll-table-card">
                    <div class="payroll-table-header">
                        <i class="ti ti-trending-down text-danger"></i>
                        <span class="text-danger">Deducciones</span>
                    </div>
                    <table class="payroll-table">
                        <thead>
                            <tr><th class="w-clave">Clave</th><th>Concepto</th><th class="text-end w-amt">Importe</th></tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of deductions">
                                <td class="w-clave">{{item.code}}</td>
                                <td>{{item.concept}}</td>
                                <td class="text-end w-amt">{{formatCurrency(item.amount)}}</td>
                            </tr>
                            <tr *ngIf="!deductions.length"><td colspan="3" class="text-center text-muted py-3">Sin deducciones registradas</td></tr>
                        </tbody>
                    </table>
                    <div class="payroll-table-total total-danger">
                        <span>Total de deducciones</span>
                        <span>{{formatCurrency(payroll.total_deductions)}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="payroll-summary-row mb-4">
            <div class="payroll-summary-card">
                <div class="payroll-summary-icon bg-success-soft"><i class="ti ti-currency-dollar text-success"></i></div>
                <div><p class="mb-0 label">Total percepciones</p><p class="mb-0 value">{{formatCurrency(payroll.total_earnings)}}</p></div>
            </div>
            <div class="payroll-summary-card">
                <div class="payroll-summary-icon bg-danger-soft"><i class="ti ti-currency-dollar text-danger"></i></div>
                <div><p class="mb-0 label">Total deducciones</p><p class="mb-0 value">{{formatCurrency(payroll.total_deductions)}}</p></div>
            </div>
            <div class="payroll-summary-card">
                <div class="payroll-summary-icon bg-info-soft"><i class="ti ti-wallet text-info"></i></div>
                <div><p class="mb-0 label">Total en efectivo</p><p class="mb-0 value">{{formatCurrency(payroll.net_cash_total)}}</p></div>
            </div>
            <div class="payroll-summary-card">
                <div class="payroll-summary-icon bg-info-soft"><i class="ti ti-file-text text-info"></i></div>
                <div><p class="mb-0 label">Neto pagado</p><p class="mb-0 value">{{formatCurrency(payroll.net_paid)}}</p></div>
            </div>
        </div>

        <div class="row g-4 mb-4">
            <div class="col-12 col-lg-6">
                <div class="payroll-info-card">
                    <p class="payroll-data-title">Resumen del período</p>
                    <div class="row g-3">
                        <div class="col-6">
                            <div class="payroll-period-row"><i class="ti ti-calendar bg-success-soft text-success"></i><span class="flex-fill">Días trabajados</span><strong>{{formatNumber(payroll.worked_days)}}</strong></div>
                            <div class="payroll-period-row"><i class="ti ti-circle-check bg-info-soft text-info"></i><span class="flex-fill">Días pagados</span><strong>{{formatNumber(payroll.paid_days)}}</strong></div>
                            <div class="payroll-period-row"><i class="ti ti-user-x bg-danger-soft text-danger"></i><span class="flex-fill">Faltas</span><strong>{{formatNumber(payroll.absences)}}</strong></div>
                        </div>
                        <div class="col-6">
                            <div class="payroll-period-row"><i class="ti ti-clock bg-purple-soft text-purple"></i><span class="flex-fill">Horas extras</span><strong>{{formatNumber(payroll.overtime_hours)}}</strong></div>
                            <div class="payroll-period-row"><i class="ti ti-users bg-teal-soft text-teal"></i><span class="flex-fill">Ausencias</span><strong>{{formatNumber(payroll.other_absences)}}</strong></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="payroll-info-card h-100">
                    <p class="payroll-data-title">Observaciones</p>
                    <div class="payroll-notes-box">{{payroll.notes || 'Sin observaciones.'}}</div>
                </div>
            </div>
        </div>

        <!-- Sección CFDI: solo cuando el recibo ya fue timbrado -->
        <div class="payroll-cfdi-container" *ngIf="isStamped">
            <div class="payroll-cfdi-header">COMPROBANTE FISCAL DIGITAL POR INTERNET (CFDI)</div>
            <div class="payroll-cfdi-body">
                <div class="row g-4">
                    <div class="col-12 col-lg-3 d-flex flex-column align-items-center gap-2">
                        <img *ngIf="payroll.qr_base64" [src]="payroll.qr_base64" alt="Código QR de verificación" class="payroll-qr-image">
                        <div class="payroll-qr-placeholder" *ngIf="!payroll.qr_base64"><i class="ti ti-qrcode"></i></div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="payroll-cfdi-field"><span class="label">Folio Fiscal (UUID)</span><span class="value">{{payroll.fiscal_folio_uuid || '--'}}</span></div>
                        <div class="payroll-cfdi-field"><span class="label">No. de serie del CSD del SAT</span><span class="value">{{payroll.sat_csd_serial || '--'}}</span></div>
                        <div class="payroll-cfdi-field"><span class="label">Forma de pago</span><span class="value">{{payroll.payment_method || '--'}}</span></div>
                        <div class="payroll-cfdi-field"><span class="label">Lugar de emisión</span><span class="value">{{payroll.issue_place || '--'}}</span></div>
                        <div class="payroll-cfdi-field"><span class="label">Fecha y hora de certificación</span><span class="value">{{formatDateTime(payroll.certification_datetime)}}</span></div>
                        <div class="payroll-cfdi-field"><span class="label">No. de serie del CSD del emisor</span><span class="value">{{payroll.issuer_csd_serial || '--'}}</span></div>
                        <div class="payroll-cfdi-field"><span class="label">Serie y folio interno</span><span class="value">{{payroll.internal_series_folio || '--'}}</span></div>
                    </div>
                    <div class="col-12 col-lg-5">
                        <div class="payroll-cfdi-breakdown">
                            <div class="row-line"><span>Total percepciones:</span><span>{{formatCurrency(payroll.total_earnings)}}</span></div>
                            <div class="row-line"><span>Total deducciones:</span><span>{{formatCurrency(payroll.total_deductions)}}</span></div>
                            <hr>
                            <div class="row-line total"><span>TOTAL NETO PAGADO:</span><span>{{formatCurrency(payroll.net_paid)}}</span></div>
                        </div>
                    </div>
                </div>

                <div class="payroll-cfdi-seals mt-4" *ngIf="payroll.digital_seal">
                    <div class="seal-block">
                        <i class="ti ti-shield-check"></i>
                        <div><p class="mb-1 fw-semibold">Sello Digital del Contribuyente Emisor:</p><p class="mb-0 seal-text">{{payroll.digital_seal}}</p></div>
                    </div>
                </div>
                <div class="payroll-cfdi-seals" *ngIf="payroll.sat_seal">
                    <div class="seal-block">
                        <i class="ti ti-shield-check"></i>
                        <div><p class="mb-1 fw-semibold">Sello Digital del SAT:</p><p class="mb-0 seal-text">{{payroll.sat_seal}}</p></div>
                    </div>
                </div>
                <div class="payroll-cfdi-seals" *ngIf="payroll.original_chain">
                    <div class="seal-block">
                        <i class="ti ti-shield-check"></i>
                        <div><p class="mb-1 fw-semibold">Cadena Original del complemento de certificación digital del SAT:</p><p class="mb-0 seal-text">{{payroll.original_chain}}</p></div>
                    </div>
                </div>
            </div>
            <div class="payroll-cfdi-footer">Este documento es una representación impresa de un CFDI</div>
        </div>
    </div>
</div>

<div class="col-xl" *ngIf="!payroll && !loading">
    <div class="card">
        <div class="card-body text-center py-5 text-muted">
            <i class="ti ti-file-x fs-1 d-block mb-2"></i>
            No se pudo cargar el recibo de nómina.
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
